import { render } from "./ManageUsersProvidersOverlay.vue?vue&type=template&id=f0ca0274&scoped=true&lang=pug"
import script from "./ManageUsersProvidersOverlay.vue?vue&type=script&lang=js"
export * from "./ManageUsersProvidersOverlay.vue?vue&type=script&lang=js"

import "./ManageUsersProvidersOverlay.vue?vue&type=style&index=0&id=f0ca0274&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ca0274"]])

export default __exports__